var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "1200px",
        "before-close": _vm.beforeClose
      }
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.batchCrawlList } },
        [
          _c("el-table-column", {
            attrs: { label: _vm.$t("Spider"), width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          size: "mini",
                          filterable: "",
                          placeholder: _vm.$t("Spider")
                        },
                        on: {
                          change: function($event) {
                            return _vm.onSpiderChange(scope.row, $event)
                          }
                        },
                        model: {
                          value: scope.row.spider_id,
                          callback: function($$v) {
                            _vm.$set(scope.row, "spider_id", $$v)
                          },
                          expression: "scope.row.spider_id"
                        }
                      },
                      _vm._l(_vm.allSpiderList, function(op) {
                        return _c("el-option", {
                          key: op._id,
                          attrs: {
                            label: op.display_name + " (" + op.name + ")",
                            value: op._id
                          }
                        })
                      }),
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("Run Type"), width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini" },
                        model: {
                          value: scope.row.run_type,
                          callback: function($$v) {
                            _vm.$set(scope.row, "run_type", $$v)
                          },
                          expression: "scope.row.run_type"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            value: "all-nodes",
                            label: _vm.$t("All Nodes")
                          }
                        }),
                        _c("el-option", {
                          attrs: {
                            value: "selected-nodes",
                            label: _vm.$t("Selected Nodes")
                          }
                        }),
                        _c("el-option", {
                          attrs: { value: "random", label: _vm.$t("Random") }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("Nodes"), width: "250px" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return scope.row.run_type === "selected-nodes"
                      ? [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "mini",
                                multiple: "",
                                placeholder: _vm.$t("Nodes")
                              },
                              model: {
                                value: scope.row.node_ids,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "node_ids", $$v)
                                },
                                expression: "scope.row.node_ids"
                              }
                            },
                            _vm._l(_vm.activeNodeList, function(n) {
                              return _c("el-option", {
                                key: n._id,
                                attrs: { label: n.name, value: n._id }
                              })
                            }),
                            1
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("Scrapy Spider"), width: "150px" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return _vm.getSpiderById(scope.row.spider_id).is_scrapy
                      ? [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "mini",
                                placeholder: _vm.$t("Scrapy Spider"),
                                disabled: !scope.row.scrapy_spider_name
                              },
                              model: {
                                value: scope.row.scrapy_spider_name,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "scrapy_spider_name", $$v)
                                },
                                expression: "scope.row.scrapy_spider_name"
                              }
                            },
                            _vm._l(
                              _vm.getScrapySpiderNames(scope.row.spider_id),
                              function(n, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: n, value: n }
                                })
                              }
                            ),
                            1
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("Scrapy Log Level"), width: "120px" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return _vm.getSpiderById(scope.row.spider_id).is_scrapy
                      ? [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("Scrapy Log Level"),
                                size: "mini"
                              },
                              model: {
                                value: scope.row.scrapy_log_level,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "scrapy_log_level", $$v)
                                },
                                expression: "scope.row.scrapy_log_level"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "INFO", label: "INFO" }
                              }),
                              _c("el-option", {
                                attrs: { value: "DEBUG", label: "DEBUG" }
                              }),
                              _c("el-option", {
                                attrs: { value: "WARN", label: "WARN" }
                              }),
                              _c("el-option", {
                                attrs: { value: "ERROR", label: "ERROR" }
                              })
                            ],
                            1
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("Parameters"), "min-width": "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input", {
                      attrs: {
                        size: "mini",
                        placeholder: _vm.$t("Parameters")
                      },
                      model: {
                        value: scope.param,
                        callback: function($$v) {
                          _vm.$set(scope, "param", $$v)
                        },
                        expression: "scope.param"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("Action"), fixed: "right", width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-button", {
                      attrs: {
                        icon: "el-icon-plus",
                        size: "mini",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onAdd(scope.$index)
                        }
                      }
                    }),
                    _c("el-button", {
                      attrs: {
                        icon: "el-icon-delete",
                        size: "mini",
                        type: "danger"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onRemove(scope.$index)
                        }
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "plain", size: "small" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "plain", size: "small" },
              on: { click: _vm.reset }
            },
            [_vm._v(" " + _vm._s(_vm.$t("Reset")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                disabled: _vm.isConfirmDisabled
              },
              on: { click: _vm.onConfirm }
            },
            [_vm._v(" " + _vm._s(_vm.$t("Confirm")) + " ")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }